import { BellOutlined } from "@ant-design/icons";
import { Avatar, Badge, Button, Dropdown, List, Menu, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IStorageState } from "../../reducers/authState/authReducer";
import InfiniteScroll from "react-infinite-scroller";
import notificationApi from "../../api/notification-api";
import moment from "moment";

const NotifiCation = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setLoadMore] = useState(true);
  const [data, setData] = useState([]);
  const [isShow, setShow] = useState(false);
  const [total, setTotal] = useState(0);
  const [totalRead, setTotalRead] = useState(0);

  const isAuth = useSelector(
    ({ auth }: { auth: IStorageState }) => auth.isAuth
  );

  const linkOnClick = async (id: any, type: any) => {
    if (!id || !type) return;
    switch (type) {
      case "NEW_COMPLAIN":
        history.push(`/orders/complain/${id}`);
        break;

      case "UPDATE_COMPLAIN_STATUS":
        history.push(`/orders/complain/${id}`);
        break;

      case "INSERT_ORDER":
        history.push(`/orders/order/${id}`);
        break;

      case "UPDATE_ORDER_STATUS":
        history.push(`/orders/order/${id}`);
        break;
      case "UPDATE_ORDER_CONTENT":
        history.push(`/orders/order/${id}`);
        break;
      case "REQUEST_CONFIRMATION":
        history.push(`/orders/order/${id}`);
        break;
      case "RE_CALL":
        history.push(`/orders/order/${id}`);
        break;
      case "REQUEST_CANCEL":
        history.push(`/orders/order/${id}`);
        break;
      case "SPLITTER_ORDER":
        history.push(`/orders/order/${id}`);
        break;
      case "NO_CONTACT":
        history.push(`/orders/order/${id}`);
        break;
      case "REQUEST_ERROR":
        history.push(`/orders/order/${id}`);
        break;
      case "REQUEST_DRAFT":
        history.push(`/orders/order/${id}`);
        break;
      case "CALL_SUCCESS":
        history.push(`/orders/order/${id}`);
        break;
      case "REQUEST_REJECT":
        history.push(`/orders/order/${id}`);
        break;
      case "ERROR":
        history.push(`/orders/order/${id}`);
        break;
      case "UPDATE_CONTENT":
        history.push(`/orders/order/${id}`);
        break;
      case "CANCEL_DELIVERED":
        history.push(`/orders/order/${id}`);
        break;
      case "REQUEST_ACCEPT":
        history.push(`/orders/order/${id}`);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    fetchData(1, (res: any) => {
      setTotal(res?.totalCount || 0);
      setData(res.data);
      setTotalRead(res?.totalOrther || 0);
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData(1, (res: any) => {
        setTotal(res?.totalCount || 0);
        setTotalRead(res?.totalOrther || 0);
        setData(res.data);
      });
      setPage(1);
    }, 30000);

    if (isShow) {
      setLoading(false);
      setLoadMore(true);
      return clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isShow, page]);

  const fetchData = async (currentPage: number, callback: Function) => {
    await notificationApi
      .getAll({
        page: currentPage,
        limit: 15,
      })
      .then((response: any) => {
        if (response.statusCode == 200) {
          callback(response);
        }
      })
      .catch(() => { });
  };

  const handleInfiniteOnLoad = async () => {
    setLoading(true);
    if (data?.length >= total) {
      setLoading(false);
      setLoadMore(false);
      return;
    }
    await fetchData(page + 1, (res: any) => {
      setPage(page + 1);
      setData(data?.concat(res?.data));
      setLoading(false);
    });
  };

  const onClickNotification = (item: any) => {
    setShow(false);
    setPage(1);
    history.push(item?.screen);
    linkOnClick(item?.idDisplay, item?.type);
    notificationApi
      .uploadType({
        isRead: true,
        id: item?._id,
      })
      .then(() => {
        fetchData(1, (res: any) => {
          setTotal(res?.totalCount || 0);
          setTotalRead(res?.totalOrther || 0);
          setData(res.data);
        });
      })
      .catch(() => { });
  };

  const onChange = (change: boolean) => {
    setShow(change);
  };

  const readAll = () => {
    data?.forEach((item: any) => {
      item.isRead = true;
    });
    notificationApi
      .readAll()
      .then(() => {
        fetchData(1, (res: any) => {
          setTotal(res?.totalCount || 0);
          setTotalRead(res?.totalOrther || 0);
          setData(res.data);
        });
      })
      .catch(() => { });
  };

  const menu = (
    <Menu className="menu-notification">
      {!isAuth ? (
        <Menu.Item></Menu.Item>
      ) : (
        <>
          <div
            key="0"
            className="strong-title-noti"
            style={{ padding: "10px" }}
          >
            <strong>THÔNG BÁO</strong>
            <Button type="link" danger onClick={readAll}>
              Đã đọc tất cả
            </Button>
          </div>
          <div
            className="notification-infinite-container"
            id="notification-infinite-container"
          >
            <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              loadMore={handleInfiniteOnLoad}
              hasMore={!loading && hasMore}
              useWindow={false}
            >
              <List
                dataSource={data}
                renderItem={(item: any) => (
                  <List.Item style={{ padding: 0 }}>
                    <Menu.Item
                      className="menu-item-notification"
                      onClick={() => onClickNotification(item)}
                    >
                      {
                        <div className="item-notification">
                          <div style={{ maxWidth: "260px" }}>
                            <div
                              className={`item-notification-content-${item?.isRead}`}
                              dangerouslySetInnerHTML={{
                                __html: `${item?.content}`,
                              }}
                            ></div>
                            <span
                              className={`date-notification date-notification-${item?.isRead}`}
                            >
                              {moment(item?.createdAt).fromNow()}
                            </span>
                          </div>
                          <div
                            className={`item-notification-is-read item-notification-is-read-${item?.isRead}`}
                          ></div>
                        </div>
                      }
                    </Menu.Item>
                  </List.Item>
                )}
              >
                {loading && hasMore && (
                  <div className="notification-loading-container">
                    <Spin />
                  </div>
                )}
              </List>
            </InfiniteScroll>
          </div>
        </>
      )}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      placement="bottomCenter"
      className="notification-dropdown"
      onVisibleChange={onChange}
    >
      <Badge count={totalRead}>
        <div className="user-dropdown">
          <Avatar
            style={{ backgroundColor: isShow ? "#4797EA" : "#D8DADF" }}
            icon={<BellOutlined style={{ fontSize: 22 }} />}
          />
        </div>
      </Badge>
    </Dropdown>
  );
};

export default NotifiCation;
